import Vue from 'vue'
import Router from 'vue-router'

import auth from '../utils/auth'

import MainPage from '../routes/main-page.vue'
import Reports from '../routes/reports.vue'
import Login from '../routes/login.vue'
import ShowReport from '../routes/show-report.vue'
import UserAccount from '../routes/user-account.vue'
import UserAdmin from '../routes/user-admin.vue'
import Favorites from '../routes/favorites.vue'
import SuperviseDashboard from '../routes/supervise-dashboard.vue'
import UserAdminByID from '../routes/user-admin-by-id.vue'
import UserAdminCreate from '../routes/user-admin-create.vue'
import SearchItems from '../routes/search-items.vue'
import ShowMetabase from '../routes/show-metabase.vue'
import ShowHelpdesk from '../routes/show-helpdesk.vue'
import ShowReportBi from '../routes/show-report-bi.vue'
import Autoservicios from '../routes/autoservicios/autoservicios.vue'
import ShowAutoservicioGroup from '../routes/autoservicios/show-autoservicio-group.vue'
import ShowProcessValidation from '../routes/autoservicios/show-process-validation.vue'
import ShowProcessBonus from '../routes/autoservicios/bonus/show-validation.vue'
import ShowProcessBonusDistributor from '../routes/autoservicios/bonus/show-bonus-distributor.vue'
import ShowProcessBonusReport from '../routes/autoservicios/bonus/show-bonus-report.vue'
import ShowAutoservicioData from '../routes/autoservicios/show-autoservicio-data.vue'
import ShowAutoServicioHomologation from '../routes/autoservicios/homologation/show-homologation.vue'
import DownloadCube from '../routes/download-cube.vue'

const PageNotFound = {
  template: `
    <div>
      The page you are looking for does not exists
      <a href="#/0">Click here to Back in black</a>
    </div>
  `
}

Vue.use(Router)

const router = new Router({
  transitionOnLoad: true,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      redirect: '/0'
    },
    {
      path: '/:folderID',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/reports/info',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/download-cube/info',
      name: 'DownloadCube',
      component: DownloadCube
    },
    {
      path: '/metabase/data',
      name: 'ShowMetabase',
      component: ShowMetabase
    },
    {
      path: '/helpdesk/info',
      name: 'ShowHelpdesk',
      component: ShowHelpdesk
    },
    {
      path: '/show-report-bi/data',
      name: 'ShowReportBi',
      component: ShowReportBi
    },
    {
      path: '/apps/info',
      name: 'Autoservicios',
      component: Autoservicios
    },
    {
      path: '/apps/group/:groupID',
      name: 'ShowAutoservicioGroup',
      component: ShowAutoservicioGroup
    },
    {
      path: '/apps/process/:processID/validacion/',
      name: 'ShowProcessValidation',
      component: ShowProcessValidation
    },
    {
      path: '/apps/process/:processID/bonificado/',
      name: 'ShowProcessBonus',
      component: ShowProcessBonus
    },
    {
      path: '/apps/process/:processID/bonificadodistribuidor',
      name: 'ShowProcessBonusDistributor',
      component: ShowProcessBonusDistributor
    },
    {
      path: '/apps/process/:processID/bonidicadoreporte',
      name: 'ShowProcessBonusReport',
      component: ShowProcessBonusReport
    },
    {
      path: '/apps/data/:processID/:id?',
      name: 'showAutoservicioData',
      component: ShowAutoservicioData
    },
    {
      path: '/apps/process/:processID/homologation',
      name: 'ShowAutoServicioHomologation',
      component: ShowAutoServicioHomologation
    },
    {
      path: '/search-item/:query',
      name: 'SearchItems',
      component: SearchItems
    },
    {
      path: '/show-report/:reportID',
      name: 'ShowReport',
      component: ShowReport
    },
    {
      path: '/show-report/:reportID/:isFavorite',
      name: 'ShowReportFavorite',
      component: ShowReport
    },
    {
      path: '/user/favorites',
      name: 'Favorites',
      component: Favorites
    },
    {
      path: '/user/account',
      name: 'UserAccount',
      component: UserAccount
    },
    {
      path: '/supervise/dashboard',
      name: 'SuperviseDashboard',
      component: SuperviseDashboard
    },
    {
      path: '/user/admin',
      name: 'UserAdmin',
      component: UserAdmin
    },
    {
      path: '/user/admin/:userID',
      name: 'UserAdminByID',
      component: UserAdminByID
    },
    {
      path: '/user/admin-create',
      name: 'UserAdminCreate',
      component: UserAdminCreate
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
})

if (!auth.isLoggedIn()) {
  router.push('login')
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js